import { ApolloQueryResult, DocumentNode } from '@apollo/client';

import { apolloClient } from '../sdk/clients/apolloClient';

export const getLinks = <ResultType>(
  query: DocumentNode
): Promise<ApolloQueryResult<ResultType>> => {
  return apolloClient.query({
    query,
  });
};
